import { render, staticRenderFns } from "./AddInvoice.vue?vue&type=template&id=7884a156&scoped=true&"
import script from "./AddInvoice.vue?vue&type=script&lang=js&"
export * from "./AddInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884a156",
  null
  
)

export default component.exports